import { Button, Dropdown } from "react-bootstrap";
import "./locationprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import { ReactSVG } from "react-svg";
import { PermissionIdentifier, PermissionModule, useModulePermissions } from "../../utils/permissionUtils";

const LocationProfileHeader = ({
  selectedLocationData,
  updateStatus,
  toggleModal,
}: any) => {

  const isPermitted = useModulePermissions(PermissionModule.LOCATION_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_LOCATION_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_LOCATION_MASTER);
  const isStatusChangePermitted = isPermitted(PermissionIdentifier.INACTIVE_LOCATION_MASTER);

  return (
    <div className="user-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedLocationData.locationCode}</h2>
        <div
          className={`status-box 
          ${selectedLocationData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedLocationData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-location">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {(isDeletePermitted || isStatusChangePermitted) && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
            {isStatusChangePermitted && (
              <Dropdown.Item onClick={() => updateStatus()}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deactivateicon}
                />
                {selectedLocationData.isActive ? "Deactivate" : "Activate"}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default LocationProfileHeader;
